// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  background-color: #1a1a2e;
  color: white;
  padding: 2rem 0;
  margin-top: auto;
  width: 100%;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  text-align: center;
}

.footer-links {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

.footer-link {
  color: #4ecca3;
  text-decoration: none;
  transition: color 0.3s ease;
  font-size: 1rem;
}

.footer-link:hover {
  color: #3db88a;
  text-decoration: underline;
}

.footer-separator {
  color: rgba(255, 255, 255, 0.5);
}

.footer-copyright {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.875rem;
}

@media (max-width: 768px) {
  .footer {
    padding: 1.5rem 0;
  }

  .footer-content {
    padding: 0 1rem;
  }

  .footer-links {
    flex-direction: column;
    gap: 0.5rem;
  }

  .footer-separator {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".footer {\n  background-color: #1a1a2e;\n  color: white;\n  padding: 2rem 0;\n  margin-top: auto;\n  width: 100%;\n}\n\n.footer-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n  text-align: center;\n}\n\n.footer-links {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  flex-wrap: wrap;\n}\n\n.footer-link {\n  color: #4ecca3;\n  text-decoration: none;\n  transition: color 0.3s ease;\n  font-size: 1rem;\n}\n\n.footer-link:hover {\n  color: #3db88a;\n  text-decoration: underline;\n}\n\n.footer-separator {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.footer-copyright {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.875rem;\n}\n\n@media (max-width: 768px) {\n  .footer {\n    padding: 1.5rem 0;\n  }\n\n  .footer-content {\n    padding: 0 1rem;\n  }\n\n  .footer-links {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .footer-separator {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
